export default class UserCreditCard {
  constructor(id='', id_user='', nickname='', flag='', id_pagarme='', id_address='', number='', name='', month='', year='', cvv='', sameAddress = false) {
    this.id = id
    this.id_user = id_user
    this.nickname = nickname
    this.flag = flag
    this.id_address = id_address
    this.id_pagarme = id_pagarme
    this.number = number
    this.name = name
    this.month = month
    this.year = year
    this.cvv = cvv
    this.sameAddress = sameAddress
  }
}
